



















































import type { PropType } from '@vue/composition-api';
import { computed, ref, defineComponent } from '@vue/composition-api';
import type { Channel } from '@getaccept/pusher';
import { ButtonType, ModalSize } from '@getaccept/lib-ui';
import type { SigningPageRecipient } from '@getaccept/lib-shared/src/types/signing-page-recipient';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import { runningOnProduction } from '../common/utils/running-on-production';
import { useEidEasy } from './eid-easy.composable';
import { EidEasy } from './constants/eid-easy.constants';
import { EidEasyFailReason } from './types/eid-easy-fail-reason';
import '@eid-easy/eideasy-widget';

export default defineComponent({
  props: {
    recipientPusherChannel: {
      type: Object as PropType<Channel>,
      required: true,
    },
    recipient: {
      type: Object as PropType<SigningPageRecipient>,
      required: true,
    },
  },
  setup(props) {
    const { retry, eidEasyDoc, error } = useEidEasy(props.recipientPusherChannel);
    const clientId = process.env.VUE_APP_EID_EASY_CLIENT_ID;
    const success = ref(false);
    const onSuccess = () => {
      success.value = true;
    };
    const header = computed(() => {
      switch (error.value) {
        case EidEasyFailReason.DocExpired:
          return t('qes_error_header_doc_expired');
        case EidEasyFailReason.OtherActiveDoc:
          return t('qes_error_header_other_active_doc');
        case EidEasyFailReason.Unknown:
          return t('qes_error_header_unknown');
        default:
          return t('sign-document');
      }
    });
    const sandboxMode = !runningOnProduction();
    const errorDescription = computed(() => {
      switch (error.value) {
        case EidEasyFailReason.DocExpired:
          return t('qes_error_desc_doc_expired');
        case EidEasyFailReason.OtherActiveDoc:
          return t('qes_error_desc_other_active_doc');
        case EidEasyFailReason.Unknown:
          return t('qes_error_desc_unknown');
        default:
          return '';
      }
    });
    const tryAgain = () => {
      success.value = false;
      retry();
    };
    return {
      eidEasyDoc,
      clientId,
      ModalSize,
      success,
      onSuccess,
      error,
      ButtonType,
      tryAgain,
      errorDescription,
      header,
      signatureMethods: EidEasy.signatureMethods,
      sandboxMode,
    };
  },
});
